import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { forwardRef } from "react";
import { useTheme } from "../../../theme/utils/useTheme";
import { useBannerContext } from "../components/BannerContext";
import { BannerActionSeparatorStyled } from "../styled/BannerActionSeparatorStyled";
export const BannerActionSeparator = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    type
  } = useBannerContext();
  const {
    key
  } = useTheme();
  const themeMode = key;
  return /*#__PURE__*/React.createElement(BannerActionSeparatorStyled, _extends({}, props, {
    themeMode: themeMode,
    bannerType: type,
    ref: ref
  }));
});
BannerActionSeparator.displayName = "BannerActionSeparator";
//# sourceMappingURL=BannerActionSeparator.js.map